import defaultPostTypeConfig from '../post'
import capitalize from '../../utils/capitalize'

export default function getConstants(p = {}) {

    const name = 'review'

    const n = name
    const N = capitalize(n)
    const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'
    const Ns = capitalize(ns)

    const {
        labels,
        menus,
        messages,
        routes,
        titles
    } = defaultPostTypeConfig.getConstants({
        ...p,
        name
    })

    return {
        labels: {
            ...labels,
            ['new' + N + 'SubmitLabel']: 'Új értékelés',
            ['restore' + N + 'SubmitLabel']: 'Visszaállítás',
            ['save' + N + 'SubmitLabel']: 'Mentés',
            ['cancel' + N + 'Text']: 'Mégsem',
            ['delete' + N + 'Text']: 'Törlés',
            ['delete' + Ns + 'Text']: 'Értékelések törlése',
            ['ban' + N + 'Text']: 'Tiltás',
            ['approve' + N + 'Text']: 'Jóváhagyás',
            ['protection' + N + 'Text']: 'Védettnek jelölés',
            ['removeProtection' + N + 'Text']: 'Védettség megszüntetése',
            ['select' + N + 'Text']: 'Kiválasztás',
            ['add' + N + 'Text']: 'Hozzáadás',
            ['date' + N + 'Format']: ({ dateText = '' }) => {
                if (!dateText) {
                    return dateText
                }
                try {
                    return new Date(dateText).toLocaleString('hu-HU')
                } catch (e) {
                }
                return dateText
            },

            [n + 'ReviewButtonBack']: 'Vissza',
            [n + 'ReviewButtonHome']: 'Főoldal',

            [ns + 'FilterLastAttemptAtFrom']: 'Utolsó megtekintés dátuma (tól)',
            [ns + 'FilterLastAttemptAtTo']: 'Utolsó megtekintés dátuma (ig)',
            [ns + 'FilterCompleted']: 'Kitöltve',
            [ns + 'FilterCompletedPlaceholder']: 'Nincs megadva',
            [ns + 'FilterCompletedOption1']: 'Kitöltve',
            [ns + 'FilterCompletedOption2']: 'Nincs kitöltve',

            [ns + 'FilterValue']: 'Értékelés száma',
            [ns + 'FilterValuePlaceholder']: 'Nincs megadva',

            [n + 'GlobalReviewSubmitLabel']: 'Küldés'
        },
        menus: {
            ...menus,
            ['user' + Ns + 'Menu']: 'Értékelések',
            ['my' + Ns + 'Menu']: 'Értékeléseim',
            ['new' + N + 'Menu']: 'Új értékelés',
            [ns + 'Menu']: 'Értékelések',
            ['deleted' + Ns + 'Menu']: 'Törölt értékelések',
            ['banned' + Ns + 'Menu']: 'Véglegesen törölt értékelések',
            ['protection' + Ns + 'Menu']: 'Védett értékelések',
            ['missingData' + Ns + 'Menu']: 'Hiányzó adatok',
            ['lowAuthorStatus' + Ns + 'Menu']: 'Szerző alacsony státusszal',

            ['edit' + N + 'Menu']: 'Szerkesztés',
            ['delete' + N + 'Menu']: 'Törlés',
            ['ban' + N + 'Menu']: 'Tiltás',
            ['approve' + N + 'Menu']: 'Jóváhagyás',
            ['protection' + N + 'Menu']: 'Védettnek jelölés',
            ['removeProtection' + N + 'Menu']: 'Védettség törlése'
        },
        messages: {
            ...messages,
            ['new' + N + 'SuccessMessage']: 'Az értékelés mentésre került',
            ['save' + N + 'SuccessMessage']: 'Az értékelés mentésre került',
            ['delete' + N + 'Success']: 'Az értékelés törölve lett',
            ['delete' + Ns + 'Success']: 'Az értékelések törölve lettek',
            ['delete' + N + 'Question']: 'Biztosan törli az értékelést?',
            ['delete' + Ns + 'Question']: 'Biztosan törli az értékeléseket?',
            ['ban' + N + 'Success']: 'Az értékelés véglegesen törölve lett',
            ['ban' + N + 'Question']: 'Biztos, hogy az értékelést véglegesen törölni akarod?',
            ['approve' + N + 'Success']: 'Az értékelés jóvá lett hagyva',
            ['approve' + N + 'Question']: 'Biztosan jóváhagyod az értékelést',
            ['protection' + N + 'Success']: 'Az értékelés védettnek jelölve',
            ['protection' + N + 'Question']: 'Biztosan védettnek jelölöd az értékelést?',
            ['removeProtection' + N + 'Success']: 'A védettnek jelölés törölve lett',
            ['removeProtection' + N + 'Question']: 'Biztosan törlöd a védettnek jelölést?',
            ['thereAreNo' + Ns]: 'Nincsenek értékelések',
            [n + 'GlobalReviewError']: 'Hiba történt az értékelés mentése közben, próbálja újra',
            [n + 'GlobalReviewSuccess']: 'Köszönjük az értékelésed!',
            [n + 'GlobalReviewFail']: 'Nem található értékelés'
        },
        routes: {
            ...routes
        },
        titles: {
            ...titles,
            [n + 'Title']: 'Értékelés',
            [ns + 'Title']: 'Értékelések',
            ['new' + N + 'Title']: 'Új értékelés',
            ['edit' + N + 'Title']: 'Értékelés szerkesztése',
            ['user' + Ns + 'Title']: 'Értékelések',
            ['userDeleted' + Ns + 'Title']: 'Törölt értékelések',
            ['my' + Ns + 'Title']: 'Értékeléseim',
            ['myDeleted' + Ns + 'Title']: 'Törölt értékeléseim',

            ['dialogDelete' + N + 'Title']: 'Értékelés törlése',
            ['dialogBan' + N + 'Title']: 'Értékelés törlése véglegesen',
            ['dialogApprove' + N + 'Title']: 'Értékelés jóváhagyása',
            ['dialogProtection' + N + 'Title']: 'Értékelés védettnek jelölése',
            ['dialogRemoveProtection' + N + 'Title']: 'Értékelés védettségének megszüntetése',

            ['dialogDelete' + Ns + 'Title']: 'Értékelések törlése',

            ['statusBanned' + N + 'Title']: 'Véglegesen törölt',
            ['statusDeleted' + N + 'Title']: 'Törölt',
            ['statusAuthorDeleted' + N + 'Title']: 'Szerző törölve',
            ['statusMissingData' + N + 'Title']: 'Hiányzó adatok',
            ['statusApproved' + N + 'Title']: 'Jóváhagyott',
            ['statusFeatured' + N + 'Title']: 'Védett',
            ['statusCreated' + N + 'Title']: 'Létrehozva',

            ['banned' + Ns + 'Title']: 'Véglegesen törölt értékelések',
            ['deleted' + Ns + 'Title']: 'Törölt értékelések',
            ['missingData' + Ns + 'Title']: 'Hiányzó adatok',
            ['protected' + Ns + 'Title']: 'Védett értékelések',
            ['lowAuthorStatus' + Ns + 'Title']: 'Szerző alacsony státusszal',

            ['select' + Ns]: 'Értékelések kiválasztása',
            ['select' + N]: 'Értékelés kiválasztása'
        }
    }
}
